import { render, staticRenderFns } from "./BGrupoDadosDetalhes.vue?vue&type=template&id=d4ef21ae"
import script from "./BGrupoDadosDetalhes.vue?vue&type=script&lang=js"
export * from "./BGrupoDadosDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports